module.exports = {
          srcSet: __webpack_public_path__ + "583e438392d275dead3e1bb64a355f66-374.png"+" 374w",
          images:[ {path: __webpack_public_path__ + "583e438392d275dead3e1bb64a355f66-374.png",width: 374,height: 280}],
          src: __webpack_public_path__ + "583e438392d275dead3e1bb64a355f66-374.png",
          toString:function(){return __webpack_public_path__ + "583e438392d275dead3e1bb64a355f66-374.png"},
          
          width: 374,
          height: 280
        }